import classNames from 'classnames';
import { Button } from 'lego-on-react';
import { uniqueId } from 'lodash';
import * as React from 'react';

import { Bem } from '../../../service/Bem/Bem';

export interface EasyBooleanFilterProps {
    name: string;
    checked: boolean;
    text: string;
    cls?: string;
    onChange: (val: string | string[] | boolean, name: string) => void;
}

export class EasyBooleanFilter extends React.Component<EasyBooleanFilterProps> {
    constructor(props: EasyBooleanFilterProps) {
        super(props);
    }

    render(): React.ReactNode {
        const { cls, text, name, checked } = this.props;

        return (
            <Button
                {...this.props}
                cls={classNames(cls, Bem.cls('easy-filters', 'filter'))}
                theme="normal"
                type="check"
                size="s"
                view="classic"
                name={name}
                checked={checked}
                text={text}
                key={uniqueId('filter')}
                onClick={this.onFilterChange}
            />
        );
    }

    private onFilterChange = () => {
        const { onChange, name, checked } = this.props;

        onChange(!checked, name);
    };
}
